import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const ProjectSettingsMergeChecksLoadable = Loadable({
  loading: LoadingPage,

  loader: () => import('./merge-checks-project-settings-page'),
});
